/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export enum IctCarbonInsightsReportTab {
	IMPACT = "IMPACT",
	HARDWARE = "HARDWARE",
	AI = "AI",
	APPLICATIONS = "APPLICATIONS",
	DATA_CENTER = "DATA_CENTER",
	CLOUD = "CLOUD"
}

export interface IctCarbonInsightsReportParams {
	from: string;
	to: string;
}
